// Contenido de la carta pública (/menu), tomado de "MENÚ LA CASA DEL TIO NEL.pdf".
// Para cambiar un precio o un plato basta con editar este archivo y volver a desplegar.

export const MENU_SECTIONS = [
    {
        id: 'desayunos',
        title: 'Desayunos',
        icon: 'bi-cup-hot',
        photos: [
            { src: 'desayuno', alt: 'Desayuno con tostadas, fruta, café y jugo natural', width: 900, height: 678 },
        ],
        items: [
            { name: 'Achachay', price: 3.5, description: 'Porción de huevos, porción de fruta, tostada de jamón y queso, café de chuspa-leche-aromática, jugo natural.' },
            { name: 'Aquisito Nomas', price: 3.75, description: 'Tigrillo, huevo frito, café de chuspa-leche-aromática, porción de fruta, jugo natural.' },
            { name: 'Tío Nel', price: 4, description: 'Torta de pollo o atún, café de chuspa-leche-aromática, porción de fruta, tortilla de tiesto, porción de mermelada, nata y queso.' },
            { name: 'Carchense', price: 4.25, description: 'Morocho, tortilla de tiesto, huevos con jamón y queso, porción de fruta con granola o cereal.' },
        ],
    },
    {
        id: 'tradicionales',
        title: 'Tradicionales',
        icon: 'bi-house-heart',
        photos: [
            { src: 'cafes', alt: 'Café, chocolate caliente y aromática sobre la mesa', width: 900, height: 678 },
        ],
        items: [
            { name: 'Mote con chicharrón', price: 3, description: 'Mote, chicharrones, tostado, papa, maduro y ensalada.' },
            { name: 'Morocho', price: 3, description: 'Incluye empanada.' },
            { name: 'Chocolate de tabla', price: 2.5, description: 'Incluye porción de queso.' },
            { name: 'Café de chuspa', price: 1.25 },
        ],
    },
    {
        id: 'platos-especiales',
        title: 'Platos especiales',
        icon: 'bi-fire',
        band: { src: 'paila', alt: 'Paila con cerdo, maduro y limón', width: 486, height: 450 },
        photos: [
            { src: 'plato-especial', alt: 'Plato con papas fritas, carne y salsas', width: 900, height: 678 },
        ],
        items: [
            { name: 'Picada de la casa', price: 6, description: 'Pollo, cerdo, chorizo, salchicha, queso, papas francesas a las finas hierbas.' },
            { name: 'Filete de pollo', price: 5.5, description: 'Acompañado de papas a la francesa, ensalada y bebida fría o caliente.' },
            { name: 'Filete de cerdo', price: 5.5, description: 'Acompañado de papas a la francesa, ensalada y bebida fría o caliente.' },
            { name: 'Tigrillo', price: 3.5, description: 'De chicharrón, queso o mixto. Acompañado de huevo frito, café de chuspa o jugo natural.' },
            { name: 'Pechuga hawaiana', price: 5.5, description: 'Pechuga de pollo bañada en salsa de piña, jamón y queso. Acompañada de porción de papas y ensalada.' },
        ],
    },
    {
        id: 'para-acompanar',
        title: 'Para acompañar',
        icon: 'bi-basket',
        photos: [
            { src: 'bolon', alt: 'Bolón con café y salsa', width: 900, height: 678 },
        ],
        items: [
            { name: 'Empanadas', price: 0.6, description: 'Pollo, queso, carne.' },
            { name: 'Bolones', price: 2, description: 'Queso, chicharrón.' },
            { name: 'Tostadas', price: 1.5, description: 'Jamón y queso.' },
            { name: 'Sánduches', price: 3.25, description: 'Pollo, jamón, queso. Acompañados de papas a la francesa.' },
            { name: 'Tortas', price: 1.5 },
        ],
    },
    {
        id: 'bebidas',
        title: 'Bebidas',
        icon: 'bi-cup-straw',
        band: { src: 'batidos', alt: 'Batidos de frutas con plátano, kiwi y fresas', width: 444, height: 438 },
        photos: [
            { src: 'hervido', alt: 'Bebida caliente servida con queso', width: 699, height: 928 },
        ],
        items: [
            { name: 'Batidos', price: 1.5, description: 'Tomate, mora, guanábana, naranjilla, maracuyá.' },
            { name: 'Jugos', price: 1, description: 'Mora, tomate, naranjilla, guanábana.' },
            { name: 'Jugo de naranja', price: 1.25 },
            { name: 'Jugo de zanahoria', price: 1.25 },
            { name: 'Aromática tradicional', price: 1 },
            { name: 'Aromática especial', price: 1.5, description: 'Frutos rojos, frutos tropicales.' },
            { name: 'Café en leche', price: 1.5 },
            { name: 'Gaseosa personal', price: 1 },
            { name: 'Gaseosa de litro', price: 2 },
            { name: 'Agua con gas', price: 1.25 },
            { name: 'Agua sin gas', price: 1 },
        ],
    },
    {
        id: 'antojitos',
        title: 'Antojitos',
        icon: 'bi-stars',
        photos: [
            { src: 'salchipapa', alt: 'Papas fritas con salchicha y salsas', width: 699, height: 928 },
        ],
        items: [
            { name: 'Papas de la casa', price: 4 },
            { name: 'Papicarne', price: 2.5 },
            { name: 'Papipollo', price: 2.5 },
            { name: 'Choripapa', price: 2 },
            { name: 'Salchipapa', price: 2 },
            { name: 'Alitas', price: 5, description: 'Promoción de viernes. Alitas bañadas en salsas de BBQ, maracuyá, tamarindo, piña, miel y mostaza, limón.' },
        ],
    },
    {
        id: 'extras',
        title: 'Extras',
        icon: 'bi-cup',
        photos: [
            { src: 'vino', alt: 'Vino caliente servido junto a una botella', width: 699, height: 928 },
        ],
        items: [
            { name: 'Cerveza de lata', price: 3 },
            { name: 'Cerveza de litro', price: 4 },
            { name: 'Hervido personal', price: 3 },
            { name: 'Vino caliente', price: 3 },
            { name: 'Brandy con leche', price: 4 },
            { name: 'Jarra de hervidos', price: 12 },
            { name: 'Jarra de vino caliente', price: 10 },
        ],
    },
];

export const formatPrice = (price) => `$${price.toFixed(2).replace('.', ',')}`;
